module.exports = __webpack_public_path__ + "static/img/18.383c5ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blog/18.png
// module id = 19EQ
// module chunks = 1